export class Program {
	constructor() {
		this.root = document.querySelector('[data-program]')
		if (!this.root) return

		this.container = this.root.querySelector('.program__container')
		this.head = document.querySelector('.program-head')
		this.nav = document.querySelector('[data-program-nav]')
		this.navList = this.nav && this.nav.querySelector('.program-nav__days')
		this.navLinks = this.nav ? Array.from(this.nav.querySelectorAll('[data-program-day-link]')) : []
		this.navHeight = 0
		this.navVisible = false
		this.currentDay = null
		this.navFrame = null
		this.daysContainer = this.root.querySelector('.program__days')
		this.days = Array.from(this.root.querySelectorAll('[data-program-day]'))
		this.links = Array.from(document.querySelectorAll('[data-program-day-link]'))
		this.tableMedia = window.matchMedia('(min-width: 768px)')
		this.drag = null
		this.draggedScroller = null
		this.frame = null
		if (this.nav && this.days.length) this.nav.hidden = false

		this.days.forEach((day) => {
			const scroller = day.querySelector('[data-program-scroller]')
			const ranges = day.querySelectorAll('[data-program-scroll]')
			const next = day.querySelector('[data-program-next]')
			const prev = day.querySelector('[data-program-prev]')
			const buttons = [prev, next]

			scroller.addEventListener('scroll', () => this.refresh(), { passive: true })
			this.initDrag(scroller)
			day.addEventListener('toggle', () => this.refresh())
			ranges.forEach((range) => {
				range.addEventListener('input', () => {
					scroller.scrollLeft = (scroller.scrollWidth - scroller.clientWidth) * Number(range.value) / 100
				})
			})
			buttons.forEach((button) => {
				button.addEventListener('click', () => {
					this.scrollColumn(day, button === prev ? -1 : 1)
				})
			})
			const filter = day.querySelector('[data-program-hide-online]')
			const onlineColumns = day.querySelectorAll('[data-program-online-class="true"]')
			filter.disabled = !onlineColumns.length
			const applyFilter = () => {
				onlineColumns.forEach((column) => { column.hidden = filter.checked })
				this.refresh()
			}
			filter.addEventListener('change', applyFilter)
			applyFilter()
		})

		this.links.forEach((link) => {
			link.addEventListener('click', (e) => {
				const day = this.days.find((item) => `#${item.id}` === link.getAttribute('href'))
				if (!day) return
				e.preventDefault()
				this.openDay(day, e.detail === 0)
				window.history.replaceState(null, '', `#${day.id}`)
			})
		})

		window.addEventListener('resize', () => this.refresh())
		window.addEventListener('pointermove', (e) => this.moveDrag(e), { passive: false })
		window.addEventListener('pointerup', (e) => this.endDrag(e))
		window.addEventListener('pointercancel', (e) => this.endDrag(e))
		window.addEventListener('blur', () => this.endDrag())
		window.addEventListener('scroll', () => this.refreshNavigation(), { passive: true })
		if ('ResizeObserver' in window) {
			this.resizeObserver = new ResizeObserver(() => this.refresh())
			this.resizeObserver.observe(this.container)
			if (this.nav) this.resizeObserver.observe(this.nav)
			if (this.head) this.resizeObserver.observe(this.head)
			this.days.forEach((day) => this.resizeObserver.observe(day.querySelector('[data-program-scroller]')))
		}
		this.update()
		const requestedDay = this.days.find((day) => `#${day.id}` === window.location.hash)
		if (requestedDay) this.openDay(requestedDay)
	}

	scrollBehavior() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
	}

	initDrag(scroller) {
		scroller.addEventListener('pointerdown', (e) => {
			if (e.pointerType !== 'mouse' || e.button !== 0 || !this.tableMedia.matches) return
			if (scroller.scrollWidth <= scroller.clientWidth + 1) return
			if (e.target.closest('a, input, select, textarea')) return
			this.drag = {
				scroller,
				pointerId: e.pointerId,
				x: e.clientX,
				y: e.clientY,
				left: scroller.scrollLeft,
				active: false
			}
		})
		scroller.addEventListener('click', (e) => {
			if (this.draggedScroller !== scroller) return
			e.preventDefault()
			e.stopImmediatePropagation()
			this.draggedScroller = null
		}, true)
		scroller.addEventListener('dragstart', (e) => e.preventDefault())
		scroller.addEventListener('lostpointercapture', () => {
			if (this.drag && this.drag.scroller === scroller) this.endDrag()
		})
	}

	moveDrag(e) {
		const drag = this.drag
		if (!drag || drag.pointerId !== e.pointerId) return
		if (!(e.buttons & 1)) {
			this.endDrag()
			return
		}
		const delta = e.clientX - drag.x
		if (!drag.active) {
			if (Math.abs(delta) < 8 || Math.abs(delta) < Math.abs(e.clientY - drag.y)) return
			drag.active = true
			this.draggedScroller = drag.scroller
			drag.scroller.classList.add('is-dragging')
			drag.scroller.setPointerCapture(e.pointerId)
		}
		e.preventDefault()
		drag.scroller.scrollLeft = drag.left - delta
	}

	endDrag(e) {
		const drag = this.drag
		if (!drag || (e && e.pointerId !== drag.pointerId)) return
		this.drag = null
		drag.scroller.classList.remove('is-dragging')
		if (drag.scroller.hasPointerCapture(drag.pointerId)) drag.scroller.releasePointerCapture(drag.pointerId)
		// click приходит после pointerup; гасим только клик завершившегося перетаскивания
		window.setTimeout(() => {
			if (this.draggedScroller === drag.scroller) this.draggedScroller = null
		}, 0)
	}

	scrollColumn(day, direction) {
		const scroller = day.querySelector('[data-program-scroller]')
		const columns = Array.from(day.querySelectorAll('[data-program-column]')).filter((column) => !column.hidden)
		if (!columns.length) return
		const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth)
		const first = columns[0].getBoundingClientRect().left
		const positions = columns.map((column) => Math.min(max, Math.max(0, column.getBoundingClientRect().left - first)))
		const current = scroller.scrollLeft
		const target = direction > 0
			? positions.find((position) => position > current + 1)
			: positions.reverse().find((position) => position < current - 1)
		const edge = direction > 0 ? max : 0
		scroller.scrollTo({ left: target === undefined ? edge : target, behavior: this.scrollBehavior() })
	}

	openDay(day, focus = false) {
		day.open = true
		this.refresh()
		window.requestAnimationFrame(() => {
			day.scrollIntoView({ behavior: this.scrollBehavior(), block: 'start' })
			if (focus) day.querySelector('summary').focus({ preventScroll: true })
		})
	}

	refresh() {
		if (this.frame !== null) return
		this.frame = window.requestAnimationFrame(() => {
			this.frame = null
			this.update()
		})
	}

	refreshNavigation() {
		if (this.navFrame !== null) return
		this.navFrame = window.requestAnimationFrame(() => {
			this.navFrame = null
			this.updateNavigation()
		})
	}

	updateNavigation(ensureCurrent = false) {
		if (!this.nav || !this.head || !this.days.length) return

		const height = this.nav.getBoundingClientRect().height
		if (height !== this.navHeight) {
			this.navHeight = height
			this.root.style.setProperty('--program-nav-height', `${height}px`)
		}
		const daysRect = this.daysContainer.getBoundingClientRect()
		// При переходе к первому дню навигация тоже остаётся над началом программы
		const visible = (this.head.getBoundingClientRect().bottom <= 0 || daysRect.top <= height + 0.5)
			&& daysRect.bottom > height
		const visibilityChanged = visible !== this.navVisible
		if (visibilityChanged) {
			this.navVisible = visible
			this.nav.classList.toggle('is-visible', visible)
			this.nav.toggleAttribute('inert', !visible)
			this.nav.setAttribute('aria-hidden', String(!visible))
		}

		let currentDay = this.days[0]
		this.days.forEach((day) => {
			const offset = parseFloat(window.getComputedStyle(day).scrollMarginTop)
			// Допускаем округление прокрутки браузером до половины пикселя
			if (day.getBoundingClientRect().top <= offset + 0.5) currentDay = day
		})
		const dayChanged = currentDay !== this.currentDay
		if (dayChanged) {
			this.currentDay = currentDay
			this.navLinks.forEach((link) => {
				const current = link.getAttribute('href') === `#${currentDay.id}`
				link.classList.toggle('is-current', current)
				if (current) link.setAttribute('aria-current', 'location')
				else link.removeAttribute('aria-current')
			})
		}
		if (visible && (dayChanged || visibilityChanged || ensureCurrent)) this.scrollNavigation()
	}

	scrollNavigation() {
		const link = this.navLinks.find((item) => item.getAttribute('href') === `#${this.currentDay.id}`)
		if (!link) return
		const listRect = this.navList.getBoundingClientRect()
		const linkRect = link.getBoundingClientRect()
		if (linkRect.left >= listRect.left && linkRect.right <= listRect.right) return
		this.navList.scrollTo({
			left: this.navList.scrollLeft + linkRect.left - listRect.left - (listRect.width - linkRect.width) / 2,
			behavior: this.scrollBehavior()
		})
	}

	update() {
		// Считаем фактические поля контейнера, включая ширину системного скроллбара
		const gutter = `${this.container.getBoundingClientRect().left}px`
		this.root.style.setProperty('--program-gutter', gutter)
		if (this.nav) this.nav.style.setProperty('--program-nav-gutter', gutter)
		this.days.forEach((day) => {
			this.links.filter((link) => link.getAttribute('href') === `#${day.id}`).forEach((link) => {
				link.classList.toggle('is-active', day.open)
				link.setAttribute('aria-expanded', String(day.open))
			})
			if (!day.open) return
			const scroller = day.querySelector('[data-program-scroller]')
			const columns = scroller.querySelector('.program__columns')
			const capacity = Number(window.getComputedStyle(columns).getPropertyValue('--columns-in-view'))
			const peek = this.tableMedia.matches && Array.from(columns.children).filter((column) => !column.hidden).length > capacity ? '40px' : '0px'
			if (columns.style.getPropertyValue('--program-peek') !== peek) columns.style.setProperty('--program-peek', peek)
			const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth)
			const overflow = this.tableMedia.matches && max > 1
			scroller.tabIndex = overflow ? 0 : -1
			scroller.classList.toggle('is-draggable', overflow)
			if (!overflow && this.drag && this.drag.scroller === scroller) this.endDrag()
			const tall = scroller.offsetHeight > window.innerHeight
			day.querySelectorAll('[data-program-scroll]').forEach((range) => {
				range.hidden = !overflow || (range.dataset.programScroll === 'top' && !tall)
				range.value = max ? Math.min(100, scroller.scrollLeft / max * 100) : 0
				const thumb = Math.max(48, range.clientWidth * scroller.clientWidth / scroller.scrollWidth)
				range.style.setProperty('--scroll-thumb-width', `${thumb}px`)
			})
			const next = day.querySelector('[data-program-next]')
			const prev = day.querySelector('[data-program-prev]')
			next.hidden = !overflow
			prev.hidden = !overflow
			next.disabled = scroller.scrollLeft >= max - 1
			prev.disabled = scroller.scrollLeft < 1
		})
		this.updateNavigation(true)
	}
}
